const Home = () => import('./views/Home.vue')
const User = () => import('./views/User.vue')
const Login = () => import('./views/Login.vue')
const Authorize = () => import('./views/Authorize.vue')
const Gift = () => import('./views/Gift.vue')
const Verify = () => import('./views/Verify.vue')
const Terms = () => import('./views/Terms.vue')
const Company = () => import('./views/Company.vue')
const PostPage = () => import('./views/PostPage.vue')
const FacebookSuccess = () => import('./views/FacebookSuccess.vue')

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    alias: '/guest/s/:site/'
  },
  {
    path: '/user',
    name: 'User',
    component: User
  },
  {
    path: '/login/:oauth?',
    name: 'Login',
    component: Login
  },
  {
    path: '/authorize',
    name: 'Authorize',
    component: Authorize,
    alias: '/skip'
  },
  {
    path: '/gift',
    name: 'Gift',
    component: Gift
  },
  {
    path: '/verify/:type',
    name: 'Verify',
    component: Verify
  },
  {
    path: '/terms/:lang',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/company/:id',
    name: 'Company',
    component: Company
  },
  {
    path: '/post/:id',
    name: 'Post',
    component: PostPage
  },
  {
    path: '/call/:tel',
    beforeEnter (to) {
      location.href = 'tel:' + to.params.tel
    }
  },
  {
    path: '/facebook/success',
    name: 'FacebookSuccess',
    component: FacebookSuccess
  }
]



// WEBPACK FOOTER //
// ./src/routes.js